export default {
  note: {
    title: 'Erityistoiveet:',
    description: 'Yritämme parhaamme mukaan toteuttaa toiveet, mutta emme voi tehdä hintaan vaikuttavia muutoksia.',
    placeholder: 'Lisää erityistoive',
  },
  buttons: {
    add: '+ Lisää tuote',
    update_item: 'Päivitä',
    add_to_card: 'Lisää koriin',
  },
  alcohol_warning: 'Tämä on ikärajoitettu tuote.',
  caffeine_warning:
    'Korkea kofeiinipitoisuus. Ei suositella lapsille, raskaana oleville tai imettäville naisille.{{value}}',
  error_messages: {
    product_unavailable: 'Loppunut!',
    item_not_added: 'Tuotetta ei voitu lisätä. Yritä uudelleen.',
  },
  success_messages: {
    item_added: 'Tuote lisätty onnistuneesti',
  },
};
